export const VAULTS_V3_MENU = [
  { path: '/', label: 'Vaults' },
  {
    path: 'https://docs.secured.finance/',
    label: 'Docs'
  },
  { path: 'https://discord.gg/3kytCrv3qY', label: 'Support', target: '_blank' },
  { path: 'https://blog.secured.finance/', label: 'Blog', target: '_blank' }
]
